import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { IGoodsClassifierDTO } from "../../../../libs/coreapi-dto/dirs/goodsClassifier";
import { useForm } from "../../../../system/hooks/useForm";
import BaseCreator from "../../../../components/creators/baseCreator";
import GridWrapper from "../../../../components/controls/GridWrapper";
import { TextInput } from "../../../../components/controls/inputs";
import modalStyles from '../../../../components/modalWindows/styles/BaseModalWindow.module.scss';
import { v4 as uuidv4 } from 'uuid';
interface IValidator {
    name: string;
}


export const GoodsClassifierCreatorModal: FC<ICreatorModalProps<IGoodsClassifierDTO>> = (props) => {
    const [goodsClassifier, setGoodsClassifier] = useState<IGoodsClassifierDTO>(props.data ?? { } as IGoodsClassifierDTO);
    const { t } = useTranslation();
    const errorsT = (value: string) => t('errors.' + value);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    
    const { isValid, errors, setErrors } = useForm<IValidator>({
        validations: {
            name: {
                required: {
                    value: goodsClassifier.name ? false : true,
                    message: errorsT("required")
                }
            },
           
        }
    });

    const handleSubmit = () => {
        if (isValid()) {
            props.save({ 
                ...goodsClassifier
            });
            setIsSubmitting(true);
        }
    }

    return (
        <>
            <BaseCreator 
                variant={props.variant} 
                isSubmitting={isSubmitting}
                save={handleSubmit}
                modalWindowClassName={modalStyles.flexModalWindow}
                cancel={props.cancel}
                valid={!props.lockFromPermission}
            >
                <GridWrapper cols={2}>
                    <TextInput 
                        labelVariant="required"
                        required
                        label={'Группа аналогов'} 
                        value={goodsClassifier.name} 
                        error={errors.name} 
                        onChange={(value) => setGoodsClassifier({ ...goodsClassifier, name: value })}
                        onFocus={() => setErrors({ ...errors, name: undefined })}
                        disabled={props.lockFromPermission}
                    />
                </GridWrapper>
            </BaseCreator>
        </>
    )
}